import React, { useContext } from 'react'
import { array } from 'prop-types'

import { ThemeContext } from '@/component/Context/ThemeContext'

import brandToColor from '@/lib/brand-to-color'
import Grid from '@/component/Primitive/Grid'
import Card from '@/component/Primitive/Card'
import Surround from '@/component/Primitive/Surround'
import CardButton from '@/component/Primitive/Card/component/CardButton'

const ExecutiveCardGrid = ({ executives }) => {
  const numPerRow = 4
  const { theme } = useContext(ThemeContext)
  const themecolor = brandToColor(theme)

  return (
    <Grid grow flex gutter="default" fullHeight>
      {executives &&
        executives.length > 0 &&
        executives.map((executive, i) => {
          const imageRatio = 347 / 220
          const imageSrc = executive.images.headshot_220x347_220[0]?.url
          return (
            <Grid.Item
              trailingGap={executives.length <= numPerRow ? null : 'default'}
              width={{ d: 1 / numPerRow }}
              key={i}
            >
              <Surround bordered="default" padded="default">
                <Card
                  typeConfig={{
                    title: { size: 'heading6' },
                    subtitle: { size: ['body2', 'body3'], color: themecolor }
                  }}
                  imageRatio={imageRatio}
                  src={imageSrc}
                  title={executive.name}
                  shouldShowSubtitle
                  subtitle={executive.jobTitle}
                  to="/executive"
                  link={`/executive/${executive.slug}`}
                  footerComponents={() => <CardButton>Read more</CardButton>}
                />
              </Surround>
            </Grid.Item>
          )
        })}
    </Grid>
  )
}

ExecutiveCardGrid.propTypes = {
  executives: array
}

export default ExecutiveCardGrid
